
import { ref, reactive, defineComponent, computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import Infomation from '@/components/block/Infomation.vue'
import HomeMainVisual from '@/components/block/HomeMainVisual.vue'
import EventBanner from '@/components/block/EventBanner.vue'
import HomeMapSearch from '@/components/block/HomeMapSearch.vue'
import HomeEasySearch from '@/components/block/HomeEasySearch.vue'
import HomeEasySearchModal from '@/components/block/HomeEasySearchModal.vue'
import HeadingLv2 from '@/components/elements/HeadingLv2.vue'
import HeadingLv3 from '@/components/elements/HeadingLv3.vue'
import HomeHospitalCassette from '@/components/block/HomeHospitalCassette.vue'
import Button from '@/components/elements/Button.vue'
import HomeRecommendSpecial from '@/components/block/HomeRecommendSpecial.vue'
import HomeRecommendSeries from '@/components/block/HomeRecommnedSeries.vue'
import JoinMyFes from '@/components/block/JoinMyFes.vue'
import SpecialFeatureCardSlider from '@/components/block/SpecialFeatureCardSlider.vue'
import HomeNews from '@/components/block/HomeNews.vue'
import LogoutModal from '@/components/genenral/ModalLogout.vue'
import AdArea from '@/components/block/AdArea.vue'
import HomeAdBanner from '@/components/block/HomeAdBanner.vue'
import { useAdBanners } from '@/provider/adBanners'
import { useRecommend } from '@/provider/recommend'
import { useSpecial } from '@/provider/special'
import { useTopSpecialFeatures } from '@/provider/topSpecialFeatures'

export default defineComponent({
  name: 'Home',

  components: {
    Infomation,
    HomeMainVisual,
    EventBanner,
    HomeMapSearch,
    HomeEasySearch,
    HomeEasySearchModal,
    HeadingLv2,
    HeadingLv3,
    HomeHospitalCassette,
    HomeRecommendSpecial,
    HomeRecommendSeries,
    JoinMyFes,
    SpecialFeatureCardSlider,
    HomeNews,
    AdArea,
    HomeAdBanner,
    LogoutModal,
    Button
  },

  setup() {
    const store = useStore()

    // top 注目の記事取得
    const {
      topSpecialFeatures,
      loadTopSpecialFeatures
    } = useTopSpecialFeatures()

    // レコメンド記事取得
    const {
      loadRecommends,
      getHomeSpecialRecommends,
      getHomeSeriesTopRecommends
    } = useRecommend()

    // 連載記事取得
    const { loadContents, getSeriesSpecialContents } = useSpecial()

    // バナー取得
    const { loadAdBanners, getRandomAdBanners } = useAdBanners()

    const state = reactive<any>({
      logoutModal: false
    })

    const easySearchModalRef = ref()

    const openEasySearchModal = (type: string) => {
      easySearchModalRef.value.easySearchModal.open(type)
    }

    const showLogoutModal = () => {
      store.commit('fixBody')
      state.logoutModal = true
      document.cookie = 'logout=; max-age=0'
    }

    const closeLogoutModal = () => {
      store.commit('unFixBody')
      state.logoutModal = false
    }

    // TODO: クッキー関連の処理を外部化したい
    // ログアウトモーダルの制御
    const cookieLogout = document.cookie
      .split('; ')
      .find((row) => row.startsWith('logout'))

    if (cookieLogout && cookieLogout.split('=')[1] === '1') {
      showLogoutModal()
    }

    onMounted(() => {
      store.dispatch('home/loadHospitalCount')
      store.dispatch('home/loadMiniNews')
      store.dispatch('home/loadNews')
      store.dispatch('home/loadEvents')
      store.dispatch('home/loadPickupHospitals')

      loadTopSpecialFeatures()
      loadRecommends()
      loadContents({ parentCategory: 'series', orderBy: 'modified' })
      loadAdBanners({ optId: 2 })

      if (store.state.isLogin) {
        store.dispatch('home/loadRecommendedHospitals')
      } else {
        // TODO: クッキー関連の処理を外部化したい
        // クッキーにTOPでエリアを検索したデータがあれば実行
        const cookieSearchAreaHome = document.cookie
          .split('; ')
          .find((row) => row.startsWith('searchAreaHome'))

        if (cookieSearchAreaHome) {
          const areaId = cookieSearchAreaHome.split('=')[1]

          store.dispatch('home/loadRecommendedHospitals', { areaId })
        }
      }
    })

    return {
      isLogin: computed(() => store.state.isLogin),
      userInfo: computed(() => store.state.userInfo),
      adBanners: computed(() => getRandomAdBanners(2)),
      hospitalCount: computed(() => store.state.home.hospitalCount),
      miniNews: computed(() => store.state.home.miniNews),
      specialRecommendContents: computed(() => getHomeSpecialRecommends()),
      seriesTopContents: computed(() => [
        ...getHomeSeriesTopRecommends(),
        ...getSeriesSpecialContents()
      ]),
      pickupHospitals: computed(
        () => store.getters['home/getEnrichedPickupHospitals']
      ),
      recommendedHospitals: computed(
        () => store.getters['home/getEnrichedRecommendedHospitals']
      ),
      state,
      openEasySearchModal,
      easySearchModalRef,
      topSpecialFeatures,
      closeLogoutModal
    }
  }
})
